import { useSelector } from "react-redux";
import IVenue from "../interfaces/IVenue";
import { IReduxAppState } from "../reducers";
import { useIsSuperuser } from "./useIsSuperuser";

/**Gets the venues the user has reports for
 * DOES NOT WORK FOR SUPERUSERs
 */
export function useReportingVenues() {
    const venues = useSelector((state: IReduxAppState) => state.venue);
    const { isSuperuser } = useIsSuperuser();

    const getReportingVenues = () => {
        const rVenues: IVenue[] = []
        if (isSuperuser) return rVenues;
        for (const id in venues) {
            const obj = venues[id];
            const vData = obj?.venueData;
            if (vData && vData.user_permissions) {
                const perms = vData.user_permissions.find((perm) => perm.permission_set === "reporting")
                if (perms.value) {
                    rVenues.push(vData);
                }
            }
        }
        return rVenues;
    }
    return { getReportingVenues };

}